import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IEditPayload {
    id: string
    data: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IListState {
    status: string
    data: any
    errors: any
}

const initialState: IListState = {
    status: STATUS.READY,
    data: null,
    errors: null
}

const editItpSlice = createSlice({
    name: 'hub/companies/itp/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editItpActions = editItpSlice.actions
export default editItpSlice.reducer
